import { whyChooseUs } from "@/data/whyChooseUs";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";

const OFFICE_IMG =
  "https://images.unsplash.com/photo-1556761175-4b46a572b786?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80";

export const WhyChooseUs = () => {
  return (
    <section
      id="why-choose-us"
      data-testid="why-choose-us-section"
      className="bg-white py-20 sm:py-24 lg:py-28"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16">
          {/* Sticky image + heading */}
          <div className="lg:sticky lg:top-28 lg:self-start">
            <SectionHeading
              chapter="07"
              kicker="Tentang Kami"
              title="Mengapa Memilih SEJUKARA?"
              description="Pendekatan yang diarahkan untuk kebutuhan perusahaan, gedung, dan fasilitas komersial."
            />
            <Reveal delay={0.15}>
              <div className="mt-8 overflow-hidden rounded-2xl border border-slate-200">
                <img
                  src={OFFICE_IMG}
                  alt="Fasilitas kerja komersial yang membutuhkan perawatan AC berkala"
                  className="aspect-[4/3] w-full object-cover"
                  loading="lazy"
                />
              </div>
            </Reveal>
          </div>

          {/* Cards */}
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {whyChooseUs.map((item, i) => {
              const Icon = item.icon;
              return (
                <Reveal key={item.id} delay={(i % 2) * 0.08}>
                  <article
                    data-testid={`why-card-${item.id}`}
                    className="group h-full rounded-2xl border border-slate-200 bg-[#F8FAFC] p-6 transition-all duration-300 hover:-translate-y-1 hover:bg-white hover:shadow-[0_18px_40px_-16px_rgba(15,23,42,0.15)]"
                  >
                    <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-[#0F172A] text-white transition-colors duration-300 group-hover:bg-[#25D366]">
                      <Icon className="h-5 w-5" />
                    </span>
                    <h3 className="mt-5 text-base font-bold text-slate-900">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-slate-600">
                      {item.description}
                    </p>
                  </article>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
